var _g, _g2, _path, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParkMapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1557_18543)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.0007,
    cy: 40.1401,
    rx: 5.1726,
    ry: 1.84736,
    fill: "black",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1557_18543)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0002 3.56201C28.5705 3.56201 35.518 10.5096 35.518 19.0798C35.518 25.6509 31.4337 31.2681 25.6652 33.5311L20.8841 40.0663C20.7844 40.2031 20.6521 40.3148 20.4982 40.3918C20.3444 40.4689 20.1736 40.5092 20.0002 40.5092C19.8269 40.5092 19.6561 40.4689 19.5022 40.3918C19.3484 40.3148 19.2161 40.2031 19.1164 40.0663L14.3352 33.5311C8.56675 31.2681 4.48242 25.6509 4.48242 19.0798C4.48242 10.5096 11.43 3.56201 20.0002 3.56201Z",
    fill: "#00A997"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1241 19.1241C32.1241 12.1862 26.4999 6.56201 19.562 6.56201C12.6242 6.56201 7 12.1862 7 19.1241C7 26.0619 12.6242 31.6861 19.562 31.6861C26.4999 31.6861 32.1241 26.0619 32.1241 19.1241Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1557_18543)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1557_18543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9298 23.2236C17.9244 23.2236 19.5472 21.3679 19.5472 19.1239C19.5472 17.3552 18.538 16.329 18.4865 16.2377C18.5124 16.0943 18.6428 15.6576 18.6428 15.0543C18.6428 13.0597 17.4259 11.4067 15.9298 11.4067C14.4337 11.4067 13.1866 13.0597 13.1866 15.0543C13.1866 15.6568 13.3178 16.0987 13.343 16.2377C13.2919 16.3282 12.2822 17.3228 12.2822 19.1239C12.2822 21.3679 13.9351 23.2236 15.9298 23.2236Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7344 26.8411H27.2644C27.5142 26.8411 27.7165 26.6388 27.7165 26.3889C27.7165 26.1391 27.5142 25.9368 27.2644 25.9368H26.8122V25.0324H27.2644C27.5142 25.0324 27.7165 24.8301 27.7165 24.5802C27.7165 24.3303 27.5142 24.128 27.2644 24.128H26.8122V22.7715C26.8122 22.5216 26.6099 22.3193 26.36 22.3193H23.6168C23.3669 22.3193 23.1646 22.5216 23.1646 22.7715V24.128H22.7124C22.4626 24.128 22.2603 24.3303 22.2603 24.5802C22.2603 24.8301 22.4626 25.0324 22.7124 25.0324H23.1646V25.9368H21.3559V24.0278C21.0636 24.0933 20.7613 24.128 20.4516 24.128C20.1466 24.128 19.8449 24.0897 19.5472 24.0207V25.9368H16.8341V24.0278C16.5419 24.0933 16.2395 24.128 15.9298 24.128C15.6201 24.128 15.3177 24.0933 15.0254 24.0278V25.9368H12.7344C12.4845 25.9368 12.2822 26.1391 12.2822 26.3889C12.2822 26.6388 12.4845 26.8411 12.7344 26.8411ZM24.069 25.0324H25.9078V25.9368H24.069V25.0324Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4568 16.0227C20.2751 17.184 20.4517 18.3326 20.4517 19.1239C20.4517 20.589 19.8694 21.9342 18.95 22.8453C19.4088 23.0826 19.9145 23.2236 20.4517 23.2236C22.4463 23.2236 24.0691 21.3679 24.0691 19.1239C24.0691 17.3228 23.0595 16.3282 23.0084 16.2377C23.0336 16.0987 23.1648 15.6568 23.1648 15.0543C23.1648 13.0597 21.9478 11.4067 20.4517 11.4067C19.8046 11.4067 19.2178 11.7228 18.751 12.2288C19.2417 13.0007 19.5473 13.9942 19.5473 15.0543C19.5473 15.4447 19.5024 15.7772 19.4568 16.0227Z",
    fill: "#0F9D58"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1557_18543",
    x: 13.3502,
    y: 36.8148,
    width: 13.3005,
    height: 6.65064,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.738955,
    result: "effect1_foregroundBlur_1557_18543"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1557_18543",
    x: 0.787648,
    y: 0.606193,
    width: 38.4247,
    height: 44.3368,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.738955
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84739
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1557_18543"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1557_18543",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1557_18543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.4343,
    height: 15.4343,
    fill: "white",
    transform: "translate(12.2822 11.4067)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1557_18543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.4343,
    height: 15.4343,
    fill: "white",
    transform: "translate(12.2822 11.4067)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkMapIcon);
export default __webpack_public_path__ + "static/media/parkMapIcon.0a0afb0fae0410ce336821fadf6d3223.svg";
export { ForwardRef as ReactComponent };